function setOpacity(obj, opacity){
	obj.style.opacity = opacity/100;
	obj.style.filter = 'alpha(opacity='+opacity+')';
	
	obj.style.display = parseInt(opacity)>0?'':'none';
}


function sub_menu(obj, act){
	
	var menuDiv = obj.getElementsByTagName("div")[0];
	
	if(menuDiv){
		if(act=="show"){
			
			menuDiv.setAttribute("isOver", "true");
			
			if(menuDiv.style.display){
				
				setOpacity(menuDiv, "0");
				
				setTimeout(function(){setOpacity(menuDiv, "20");}, 20);
				setTimeout(function(){setOpacity(menuDiv, "30");}, 40);
				setTimeout(function(){setOpacity(menuDiv, "40");}, 60);
				setTimeout(function(){setOpacity(menuDiv, "50");}, 80);
				setTimeout(function(){setOpacity(menuDiv, "60");}, 100);
				setTimeout(function(){setOpacity(menuDiv, "70");}, 120);
				setTimeout(function(){setOpacity(menuDiv, "80");}, 140);
				setTimeout(function(){setOpacity(menuDiv, "90");}, 160);
				setTimeout(function(){setOpacity(menuDiv, "100");}, 180);
				
			}
			
		}else{
			
			menuDiv.setAttribute("isOver", "false");
			
			setTimeout(function(){
				
				if(menuDiv.getAttribute('isOver')!="true"){
					
					setTimeout(function(){setOpacity(menuDiv, "100");}, 20);
					setTimeout(function(){setOpacity(menuDiv, "90");}, 40);
					setTimeout(function(){setOpacity(menuDiv, "80");}, 60);
					setTimeout(function(){setOpacity(menuDiv, "70");}, 80);
					setTimeout(function(){setOpacity(menuDiv, "60");}, 100);
					setTimeout(function(){setOpacity(menuDiv, "50");}, 120);
					setTimeout(function(){setOpacity(menuDiv, "40");}, 140);
					setTimeout(function(){setOpacity(menuDiv, "30");}, 160);
					setTimeout(function(){setOpacity(menuDiv, "20");}, 180);
					setTimeout(function(){setOpacity(menuDiv, "0");}, 200);
					
				}
				
			}, "10");
		}
	}
}

function round_number(n, d) {  
	n = n - 0;  
	if (d == null) d = 2;  
	var f = Math.pow(10, d);  
	n += Math.pow(10, - (d + 1));  
	n = Math.round(n * f) / f;  
	n += Math.pow(10, - (d + 1));  
	n += '';  
	return d == 0 ? n.substring(0, n.indexOf('.')) :  n.substring(0, n.indexOf('.') + d + 1);  
} 

function showMenu(obj, num){
	
	if(obj && obj.prentNode && obj.parentNode.childNodes){
		
		var obj = obj.parentNode.childNodes;
		var selfIndex = obj.index;
		
		var hide = true;
		
		if(obj){
			
			for(var i in obj){
				
				if(obj[i] && (obj[i].nodeName=='A' || obj[i].nodeName=='UL')){
					
					if(obj[i].nodeName=='A'){
						hide = obj[i].name==num?false:true;
					}else if(obj[i].nodeName=='UL'){
						obj[i].style.display = hide?'none':'';
					}
					
				}
				
			}
			
		}
		
	}
	
}





function inArray(what, where){
	
	what = what.toString();
	
	for(var i in where){
		if(where.hasOwnProperty(i) && where[i].toString()==what){
			return true;
		}
	}
	
	return false;
	
}

function setCities(obj){
	
	var country_selector = document.getElementById('country_selector');
	
	var curier_selector = document.getElementById("curier_selector");
	curier_selector.innerHTML = '';
	
	var citiesPlace = document.getElementById("citiesPlace");
	citiesPlace.innerHTML = '';
		
		if(obj.value){
			
			//------ Getting new city options ---------|
				
				var req = new JsHttpRequest();
				req.onreadystatechange = function(){
					if(req.readyState == 4){
						
						if(req.responseText && document.getElementById('debug')){
							document.getElementById('debug').innerHTML = req.responseText;
						}
						
						if(req.responseJS && req.responseJS.cities){
							
							citiesPlace.innerHTML = '';
							
							var totalCities = 0;
							var firstCityInput = false;
							
							for(var key in req.responseJS.cities){
								
								if(req.responseJS.cities[key]['id']){
									
									var div = document.createElement('div');
									div.className = 'form_radio';
										
										var input = document.createElement('input');
										input.type = 'radio';
										input.name = 'delivery[city]';
										input.setAttribute('required', 'required');
										input.value = req.responseJS.cities[key]['id'];
										input.id = 'dc'+req.responseJS.cities[key]['id'];
										input.onclick = function(){checkSelectedCity(this.value, this);}
										div.appendChild(input);
										
										if(!totalCities){
											firstCityInput = input;
										}
										
										var label = document.createElement('label');
										label.setAttribute('for', 'dc'+req.responseJS.cities[key]['id']);
										label.appendChild(document.createTextNode(req.responseJS.cities[key]['name']));
										div.appendChild(label);
										
									citiesPlace.appendChild(div);
									
									if(req.responseJS.cities[key]['id']==7){
										
										var p = document.createElement('p');
										p.className = 'form_radio_checkbox';
										p.style.cssText = 'display:none;padding-left:50px;';
											
											var input = document.createElement('input');
											input.type = 'checkbox';
											input.id = 'recipientDataCheckBox';
											input.onclick = function(){checkRecipientData();}
											p.appendChild(input);
											
											p.appendChild(document.createTextNode(' '+words['recipient_not_same']));
											
										citiesPlace.appendChild(p);
										
									}
									
									totalCities++;
									
								}
								
							}
							
							if(totalCities<2 && firstCityInput){
								checkSelectedCity(firstCityInput.value, firstCityInput);
							}
							
						}
						
					}
				}
				
				req.caching = false;
				req.open('GET', location.href, true);
				req.send({'userAction': 'getCities', 'country': obj.value});
				
			//------ Getting new city options ---------|
			
		}
		
	
	var tmpObj = document.getElementsByClassName('order_item');
	for(var i in tmpObj){
		if(tmpObj.hasOwnProperty(i) && tmpObj[i].getAttribute('name')){
			tmpObj[i].style.display = 'none';
		}
	}
	
	if(country_selector.value=='122'){
		rebuildOmniva('LT');
		rebuildVenipak('LT');
	}else if(country_selector.value=='125'){
		rebuildOmniva('LV');
		rebuildVenipak('LV');
	}else if(country_selector.value=='2'){
		rebuildOmniva('EE');
		rebuildVenipak('EE');
	}
	
	//document.getElementById('vatPlace').style.display = 'none';
	//document.getElementById('vatPlace').setAttribute('name', 'nothing');
	//document.getElementById('vatPlace').getElementsByTagName('input')[0].value = '';
	
	checkShowFirm();
	
}

function setCuriers(cityId){
	
	var curier_selector = document.getElementById("curier_selector");
	curier_selector.parentNode.style.display = 'none';
	curier_selector.innerHTML = '';
	
	curier_selector.onchange = function(){
		
		var total_price = 0;
		var total_notax_price = 0;
		
		var delivery_time_text = 0;
		
		for(key in this.options){
			if(this.options[key] && this.options[key].nodeName=='OPTION' && this.options[key].selected){
				total_price = this.options[key].getAttribute('total_price');
				total_notax_price = this.options[key].getAttribute('total_notax_price');
				delivery_time_text = this.options[key].getAttribute('delivery_time_text');
				break;
			}
		}
		
		document.getElementById('total_with_delivery_cost').innerHTML = total_price;
		document.getElementById('total_with_delivery_cost_notax').innerHTML = total_notax_price;
		
		document.getElementById('withoutVatPrice').innerHTML = total_notax_price;
		
		document.getElementById('total_delivery_time').innerHTML = delivery_time_text;
		document.getElementById('total_delivery_time_place').style.display = (delivery_time_text && delivery_time_text!='0')?'':'none';
		
		checkVatValue();
		
	}
	
	document.getElementById('loadingBar').style.display = '';
	
	if(cityId){
		
		//--------- Getting curiers list ----------|
			
			var req = new JsHttpRequest();
			req.onreadystatechange = function(){
				if(req.readyState == 4){
					
					if(req.responseText && document.getElementById('debug')){
						document.getElementById('debug').innerHTML = req.responseText;
					}
					
					document.getElementById('loadingBar').style.display = 'none';
					curier_selector.innerHTML = '';
					
					if(req.responseJS && req.responseJS.curiers){
						
						var totalOptions = 0;
						
						for(var key in req.responseJS.curiers){
							
							if(req.responseJS.curiers[key]['id']){
								
								totalOptions++;
								
								var option = document.createElement("option");
									option.setAttribute('total_price', req.responseJS.curiers[key]['total_price']);
									option.setAttribute('total_notax_price', req.responseJS.curiers[key]['total_notax_price']);
									option.setAttribute('delivery_time_text', req.responseJS.curiers[key]['delivery_time_text']);
									option.setAttribute('required', 'required');
									option.value = req.responseJS.curiers[key]['id'];
									option.appendChild(document.createTextNode(req.responseJS.curiers[key]['name']+(req.responseJS.curiers[key]['price']>0?(": "+req.responseJS.curiers[key]['price']+' '+req.responseJS.curiers[key]['currency']):"")));
								curier_selector.appendChild(option);
								
							}
							
						}
						
						curier_selector.parentNode.style.display = totalOptions>1?'':'none';
						curier_selector.onchange();
						
					}
					
				}
			}
			
			req.caching = false;
			req.open('GET', location.href, true);
			req.send({'userAction': 'getCuriers', 'city': cityId});
			
		//--------- Getting curiers list ----------|
		
	}
	
	checkShowFirm();
	
}


var selectedCurier = '';
var out_delivery_details, out_sms_number;

function checkShowFirm(){
	
	var isBusiness = document.getElementById('business_checkbox').checked?true:false;
	document.getElementById('company_data_form').style.display = isBusiness?'':'none';
	
	var tmpInput = document.getElementById('company_data_form').getElementsByTagName('input');
	for(var i=0;i<tmpInput.length;i++){
		if(tmpInput[i] && tmpInput[i].nodeName=='INPUT' && tmpInput[i].getAttribute('check') && tmpInput[i].getAttribute('check')=='true'){
			if(isBusiness){
				tmpInput[i].setAttribute('required', 'required');
			}else{
				tmpInput[i].removeAttribute('required');
			}
		}
	}
	
	checkVatPlace();
	
}

function checkVatPlace(){
	
	var showVATForm = false;
	
	var isBusiness = document.getElementById('business_checkbox').checked?true:false;
	if(isBusiness){
		var country_selector = document.getElementById('country_selector');
		if(country_selector.value && country_selector.value!='2'){
			showVATForm = true;
		}
	}
	
	var tmpObj = document.getElementsByClassName('order_item');
	for(var i in tmpObj){
		if(tmpObj.hasOwnProperty(i) && tmpObj[i].getAttribute('name') && tmpObj[i].getAttribute('name')=='vat_nr'){
			tmpObj[i].style.display = showVATForm?'':'none';
		}
	}
	
}

function checkRecipientData(){
	
	if(document.getElementById('recipientDataCheckBox')){
		var recipientDataCheckBox = document.getElementById('recipientDataCheckBox').checked?true:false;
		document.getElementById('additional_recipient_data').style.display = document.getElementById('recipientDataCheckBox').checked?'':'none';
	}
	
	var tmpInput = document.getElementById('additional_recipient_data').getElementsByTagName('input');
	for(var i=0;i<tmpInput.length;i++){
		if(tmpInput[i] && tmpInput[i].nodeName=='INPUT' && tmpInput[i].getAttribute('check') && tmpInput[i].getAttribute('check')=='true'){
			if(document.getElementById('recipientDataCheckBox') && document.getElementById('recipientDataCheckBox').checked){
				tmpInput[i].setAttribute('required', 'required');
			}else{
				tmpInput[i].removeAttribute('required');
			}
		}
	}
	
}

function checkSelectedCity(selectedCity, optObj){
	
	//--------- Selecting option -----------|
		
		var inputs = optObj.parentNode.parentNode.parentNode.getElementsByTagName('input');
		
		for(var i in inputs){
			if(inputs[i] && inputs[i].nodeName=='INPUT' && inputs[i].type=='radio' && inputs[i].name=='delivery[city]'){
				inputs[i].checked = false;
			}
		}
		
		optObj.checked = true;
		
	//--------- Selecting option -----------|

	var tmpObj = document.getElementsByClassName('order_item');
	for(var i in tmpObj){
		if(tmpObj.hasOwnProperty(i) && tmpObj[i].getAttribute('name') && tmpObj[i].getAttribute('name')=='recipient_data'){
			
			tmpObj[i].style.display = selectedCity==7?'':'none';
			
			var tmpInput = tmpObj[i].getElementsByTagName('input');
			for(var i=0;i<tmpInput.length;i++){
				if(tmpInput[i] && tmpInput[i].nodeName=='INPUT' && tmpInput[i].getAttribute('check') && tmpInput[i].getAttribute('check')=='true'){
					if(selectedCity==7){
						tmpInput[i].setAttribute('required', 'required');
					}else{
						tmpInput[i].removeAttribute('required');
					}
				}
			}
			
		}
	}

	if(document.getElementById('recipientDataCheckBox')){
		if(selectedCity==7){
			document.getElementById('recipientDataCheckBox').parentNode.style.display = '';
		}else{
			document.getElementById('recipientDataCheckBox').parentNode.style.display = 'none';
			document.getElementById('recipientDataCheckBox').checked = false;
		}
	}
	
	if(selectedCity){
		
		var showBlocks = {
			7: ['recipient_data'],
			4: ['smartpost'],
			118: ['smartpost_fi'],
			111: ['dpd'],
			120: ['omniva'],
			123: ['omniva'],
			126: ['omniva'],
			141: ['venipak'],
		};
		
		var tmpObj = document.getElementsByClassName('order_item');
		for(var i in tmpObj){
			if(tmpObj.hasOwnProperty(i) && tmpObj[i].getAttribute('name')){
				
				if(showBlocks[selectedCity] && inArray(tmpObj[i].getAttribute('name'), showBlocks[selectedCity])){
					tmpObj[i].style.display = '';
					selectedCurier = tmpObj[i].getAttribute('name');
				}else{
					tmpObj[i].style.display = 'none';
				}
				
			}
		}
		
	}
	
	checkShowFirm();
	checkRecipientData();
	setCuriers(selectedCity);
	
}

function setDeliveryDetails(formObj){
	
	//-------- Getting all form fields -----------|
		
		var fieldValues = {};
			
			var input = formObj.getElementsByTagName('input');
			for(var i=0;i<input.length;i++){
				fieldValues[input[i].name] = input[i].value;
			}
			
			var select = formObj.getElementsByTagName('select');
			for(var i=0;i<select.length;i++){
				fieldValues[select[i].name] = select[i].value;
			}
			
		
		out_delivery_details = '';
		out_sms_number = '';
		
		if(selectedCurier=='smartpost'){
			out_delivery_details = fieldValues['order[smartpost_location]'];
			out_sms_number = fieldValues['order[smartpost_sms_number]'];
		}else if(selectedCurier=='smartpost_fi'){
			out_delivery_details = fieldValues['order[smartpost_fi_location]'];
			out_sms_number = fieldValues['order[smartpost_fi_sms_number]'];
		}else if(selectedCurier=='omniva'){
			out_delivery_details = fieldValues['order[omniva_location]'];
			out_sms_number = fieldValues['order[omniva_sms_number]'];
		}else if(selectedCurier=='venipak'){
			out_delivery_details = fieldValues['order[venipak_location]'];
			out_sms_number = fieldValues['order[venipak_sms_number]'];
		}else if(selectedCurier=='dpd'){
			out_delivery_details = fieldValues['order[dpd_location]'];
		}
		
		//console.warn(selectedCurier);
		//console.warn(out_delivery_details);
		
	//-------- Getting all form fields -----------|
	
}

function checkVatValue(){
	
	var vatValue = document.getElementById('reg_firm_vat').value.toUpperCase();
	var reg = new RegExp("^([a-z]{2})([0-9]+)$", "i");
	
	if(vatValue.substr(0, 2)!="EE" && vatValue.search(reg)!=-1){
		document.getElementById('vatVal1').style.display = '';
		document.getElementById('vatVal2').style.display = '';
		document.getElementById('total_with_delivery_cost').style.display = 'none';
		document.getElementById('total_with_delivery_cost_notax').style.display = '';
	}else{
		document.getElementById('vatVal1').style.display = 'none';
		document.getElementById('vatVal2').style.display = 'none';
		document.getElementById('total_with_delivery_cost').style.display = '';
		document.getElementById('total_with_delivery_cost_notax').style.display = 'none';
	}
	
}

function rebuildOmniva(countryCode){
	
	//------- Building groups -------|
		
		var omnivaData = [];
			
			for(var i in omnivaDataOriginal){
				
				if(omnivaDataOriginal[i] && omnivaDataOriginal[i]['state'] && omnivaDataOriginal[i]['country']==countryCode){
					
					var tmpName = omnivaDataOriginal[i]['state'];
					
					if(typeof(omnivaData[tmpName])=='undefined'){
						omnivaData[tmpName] = [];
					}
					
					omnivaData[tmpName].push(omnivaDataOriginal[i]);
					
				}
				
			}
			
		
	//------- Building groups -------|
	
	
	//--------- Generating omniva Selector -----------|	
		
		var omniva_select = document.getElementById('omniva_select');
		omniva_select.innerHTML = '';
			
			var option = document.createElement('option');
			option.innerHTML = '- '+words['omniva_place']+' -';
			option.value = '';
			omniva_select.appendChild(option);
			
		
		for(var groupName in omnivaData){
			
			if(omnivaData[groupName] && omnivaData[groupName][0]){
				
				var optgroup = document.createElement('optgroup');
					
					optgroup.label = groupName;
					
					for(var i in omnivaData[groupName]){
						
						if(omnivaData[groupName][i] && omnivaData[groupName][i]['shop']){
							
							var option = document.createElement('option');
								
								option.value = groupName+'|'+i;
								option.innerHTML = omnivaData[groupName][i]['shop'];
								option.style.paddingLeft = '20px';
								
							optgroup.appendChild(option);
							
						}
						
					}
					
					
				omniva_select.appendChild(optgroup);
				
			}
			
		}
		
		omniva_select.onchange = function(){
			
			var tmp = this.value.split('|');
			
			if(tmp[0] && tmp[1] && omnivaData[tmp[0]] && omnivaData[tmp[0]][tmp[1]]){
				
				var tmpData = omnivaData[tmp[0]][tmp[1]];
				
				document.getElementById('omniva_city').value = tmpData['city'];
				document.getElementById('omniva_address').value = tmpData['adress'];
				document.getElementById('omniva_open').value = tmpData['work_time'];
				document.getElementById('omniva_description').value = tmpData['information'];
				
				document.getElementById('omniva_delivery_details_field').value = tmp[0]+' / '+tmpData['shop'];
				
			}else{
				
				document.getElementById('omniva_city').value = '';
				document.getElementById('omniva_address').value = '';
				document.getElementById('omniva_open').value = '';
				document.getElementById('omniva_description').value = '';
				
				document.getElementById('omniva_delivery_details_field').value = '';
				
			}
			
		}
		
		omniva_select.onchange();
		
	//--------- Generating omniva Selector -----------|
	
}

function htmlEntityDecode(text){
	
	text = text.split('&Atilde;&curren;').join('&auml;');
	
	var tmpTextarea = document.createElement('textarea');
    tmpTextarea.innerHTML = text;
    return tmpTextarea.value;
	
}


function rebuildVenipak(countryCode){
	
	//------- Building groups -------|
		
		var venipakData = [];
			
			if(venipakDataOriginal && venipakDataOriginal[0]){
				
				for(var i in venipakDataOriginal[0]){
					
					if(venipakDataOriginal[0][i] && venipakDataOriginal[0][i][0] && venipakDataOriginal[0][i][0]==countryCode){
						
						//console.warn('-----');
						//console.warn(venipakDataOriginal[0][i]);
						
						if(venipakDataOriginal[0][i][0]){
							
							var tmpGroupName = venipakDataOriginal[0][i][1];
								
								if(typeof(venipakData[tmpGroupName])=='undefined'){
									venipakData[tmpGroupName] = [];
								}
								
							
							for(var xi in venipakDataOriginal[0][i][2]){
								
								//console.warn(venipakDataOriginal[0][i][2][xi]);
								
								venipakData[tmpGroupName].push({
									'shop': venipakDataOriginal[0][i][2][xi][0],
									'city': venipakDataOriginal[0][i][2][xi][1],
									'adress': venipakDataOriginal[0][i][2][xi][2],
									'work_time': venipakDataOriginal[0][i][2][xi][3],
									'information': venipakDataOriginal[0][i][2][xi][4],
									'country_code': venipakDataOriginal[0][i][2][xi][5],
								});
								
							}
							
						}
						
					}
					
				}
				
			}
			
		
		//console.warn(venipakDataOriginal);
		//console.warn(venipakData);
		
	//------- Building groups -------|
	
	
	//--------- Generating venipak Selector -----------|	
		
		var venipak_select = document.getElementById('venipak_select');
		venipak_select.innerHTML = '';
			
			var option = document.createElement('option');
			option.innerHTML = '- '+words['venipak_place']+' -';
			option.value = '';
			venipak_select.appendChild(option);
			
		
		for(var groupName in venipakData){
			
			if(venipakData[groupName] && venipakData[groupName][0]){
				
				var optgroup = document.createElement('optgroup');
					
					optgroup.label = groupName;
					
					for(var i in venipakData[groupName]){
						
						if(venipakData[groupName][i] && venipakData[groupName][i]['shop']){
							
							//console.warn(venipakData[groupName][i]);
							
							var option = document.createElement('option');
								
								option.setAttribute('json_data', JSON.stringify(venipakData[groupName][i]));
								option.innerHTML = venipakData[groupName][i]['shop']+', '+venipakData[groupName][i]['city'];
								option.style.paddingLeft = '20px';
								
							optgroup.appendChild(option);
							
						}
						
					}
					
					
				venipak_select.appendChild(optgroup);
				
			}
			
		}
		
		venipak_select.onchange = function(){
			
			var tmpData = false;
				
				for(var i in this.options){
					if(this.value==this.options[i].value){
						tmpData = JSON.parse(this.options[i].getAttribute('json_data'));
						break;
					}
				}
				
			
			if(tmpData && tmpData['shop']){
				
				document.getElementById('venipak_city').value = htmlEntityDecode(tmpData['city']);
				document.getElementById('venipak_address').value = htmlEntityDecode(tmpData['adress']);
				document.getElementById('venipak_open').value = htmlEntityDecode(tmpData['work_time']);
				document.getElementById('venipak_description').value = htmlEntityDecode(tmpData['information']);
				
				document.getElementById('venipak_delivery_details_field').value = tmpData['country_code']+' / '+tmpData['city']+' / '+htmlEntityDecode(tmpData['shop']);
				
			}else{
				
				document.getElementById('venipak_city').value = '';
				document.getElementById('venipak_address').value = '';
				document.getElementById('venipak_open').value = '';
				document.getElementById('venipak_description').value = '';
				
				document.getElementById('venipak_delivery_details_field').value = '';
				
			}
			
		}
		
		venipak_select.onchange();
		
	//--------- Generating venipak Selector -----------|
	
}

var basketClass = function(){
	
	var lastPopUpNotice = false;
	var noticesId = 1;
	
	var popUpBoxShadowObj, popUpBoxObj, popUpBoxContentObj;
	
	var popUpContentTemplate	 = '		<h1>{item:name}</h1>';
	popUpContentTemplate 		+= '		<h2>{word:added_to_cart}</h2>';
	popUpContentTemplate	 	+= '		<div class="basket_add_warranty__btn">';
	popUpContentTemplate	 	+= '			<button class="s_btn" onclick="basket.closePopUp();">{word:continue_shopping}</button>';
	popUpContentTemplate 		+= '			<button class="s_btn" onclick="location.href=\'{item:basket}\'">{word:make_order}</button>';
	popUpContentTemplate 		+= '		</div>';
	
	this.closePopUp = function(){
		popUpBoxShadowObj.style.display = 'none';
		popUpBoxObj.style.display = 'none';
	}
	
	this.addItem = function(obj, id, quantity){
		
		lastUpdatedAdditionals = false;
		
		if(!popUpBoxObj){
			
			var bodyObj = document.getElementsByTagName('body')[0];
			
			popUpBoxShadowObj = document.createElement('div');
			popUpBoxShadowObj.className = 'modal_box__shadow modal_box__shadow__show';
			popUpBoxShadowObj.style.display = 'none';
			popUpBoxShadowObj = bodyObj.insertBefore(popUpBoxShadowObj, bodyObj.childNodes[0]);
			
			popUpBoxObj = document.createElement('div');
			popUpBoxObj.className = 'modal_box modal_box__active';
			popUpBoxObj.setAttribute('aria-hidden', 'true');
			popUpBoxObj.innerHTML = '<div class="modal_box__wrap"><div class="modal_box__window basket_add_warranty" role="dialog" aria-modal="true"><button data-hystclose="" class="modal_box__close" onclick="basket.closePopUp();">{word:close}</button><div class="popUpContent"></div></div></div>';
			popUpBoxObj.style.display = 'none';
			popUpBoxObj = bodyObj.insertBefore(popUpBoxObj, bodyObj.childNodes[0]);
			
			popUpBoxContentObj = popUpBoxObj.getElementsByClassName('popUpContent')[0];
			
		}
		
		if(popUpBoxObj && popUpBoxObj.style.display=='none'){
			
			var to_basket = {};
			to_basket[id] = {'quantity': quantity}
			
			if(lastPopUpNotice){
				lastPopUpNotice.className = 'popUpNotice';
			}
			
			//----- Sending save request ------|
				
				popUpBoxContentObj.innerHTML = '';
				popUpBoxShadowObj.style.display = '';
				
				var req = new JsHttpRequest();
				
				req.onreadystatechange = function(){
					if(req.readyState == 4){
						
						if(req.responseJS['item']){
							
							templateTmp = popUpContentTemplate;
								
								if(req.responseJS['words']){
									for(var field in req.responseJS['words']){
										if(req.responseJS['words'].hasOwnProperty(field) && typeof(req.responseJS['words'][field])=='string'){
											templateTmp = templateTmp.split('{word:'+field+'}').join(req.responseJS['words'][field]);
										}
									}
								}
								
								if(req.responseJS['item']){
									for(var field in req.responseJS['item']){
										if(req.responseJS['item'].hasOwnProperty(field) && typeof(req.responseJS['item'][field])=='string'){
											templateTmp = templateTmp.split('{item:'+field+'}').join(req.responseJS['item'][field]);
										}
									}
								}
								
							popUpBoxContentObj.innerHTML = templateTmp;
							
							popUpBoxContentObj.setAttribute('key', req.responseJS['item']['key']);
							
							if(req.responseJS['item']['additional_offers']){
								
								var buttonsObj = popUpBoxContentObj.getElementsByClassName('basket_add_warranty__btn')[0];
								
								var p = document.createElement('p');
								p.innerHTML = req.responseJS['words']['additional_offers_title']+'<br><br>';
								popUpBoxContentObj.insertBefore(p, buttonsObj);
								
								var warranty_box = document.createElement('div');
								warranty_box.className = 'warranty_box';
									
									for(var oi in req.responseJS['item']['additional_offers']){
										
										if(req.responseJS['item']['additional_offers'].hasOwnProperty(oi) && req.responseJS['item']['additional_offers'][oi]){
											
											var warranty_item = document.createElement('div');
											warranty_item.className = 'warranty_item';
												
												var input = document.createElement('input');
												input.type = 'checkbox';
												input.id = 'l'+req.responseJS['item']['additional_offers'][oi]['id'];
												input.className = 'warranty_item__ch';
												input.onclick = input.onchange = input.onblur = function(){basket.saveAdditionals();}
												warranty_item.appendChild(input);
												
												var label = document.createElement('label');
												label.setAttribute('for', 'l'+req.responseJS['item']['additional_offers'][oi]['id']);
												label.className = 'warranty_item__label';
												warranty_item.appendChild(label);
												
												var warranty_item__content = document.createElement('div');
												warranty_item__content.className = 'warranty_item__content';
													
													var warranty_item__name = document.createElement('span');
													warranty_item__name.className = 'warranty_item__name';
														
														var a = document.createElement('a');
														a.href = req.responseJS['item']['additional_offers'][oi]['href'];
														a.target = '_blank';
														a.appendChild(document.createTextNode(req.responseJS['item']['additional_offers'][oi]['name']));
														warranty_item__name.appendChild(a);
														
														if(req.responseJS['item']['additional_offers'][oi]['name2']){
															warranty_item__name.appendChild(document.createTextNode(' - '+req.responseJS['item']['additional_offers'][oi]['name2']));
														}
														
													warranty_item__content.appendChild(warranty_item__name);
													
													var warranty_item__var = document.createElement('select');
													warranty_item__var.name = req.responseJS['item']['additional_offers'][oi]['id'];
													warranty_item__var.onclick = warranty_item__var.onchange = warranty_item__var.onblur = function(){
														this.parentNode.parentNode.getElementsByTagName('input')[0].checked = true;
														basket.saveAdditionals();
													}
														
														if(req.responseJS['item']['additional_offers'][oi]['offers']){
															
															for(var oio in req.responseJS['item']['additional_offers'][oi]['offers']){
																if(req.responseJS['item']['additional_offers'][oi]['offers'].hasOwnProperty(oio)){
																	
																	var option = document.createElement('option');
																	option.value = req.responseJS['item']['additional_offers'][oi]['offers'][oio]['id'];
																	option.innerHTML = req.responseJS['item']['additional_offers'][oi]['offers'][oio]['name']+' &euro; '+req.responseJS['item']['additional_offers'][oi]['offers'][oio]['price'];
																	warranty_item__var.appendChild(option);
																	
																}
															}
															
														}
														
													warranty_item__content.appendChild(warranty_item__var);
													
												warranty_item.appendChild(warranty_item__content);
												
											warranty_box.appendChild(warranty_item);
											
										}
									}
									
								popUpBoxContentObj.insertBefore(warranty_box, buttonsObj);
								
							}
							
							popUpBoxObj.style.display = '';
							
						}else if(req.responseJS['error']){
							
							popUpBoxContentObj.innerHTML = '';
								
								for(var i in req.responseJS['error']){
									
									var p = document.createElement('p');
									p.innerHTML = req.responseJS['error'][i];
									popUpBoxContentObj.appendChild(p);
									
								}
								
							popUpBoxObj.style.display = '';
							
						}else if(req.responseJS['notice']){
							
							popUpBoxContentObj.innerHTML = '';
								
								for(var i in req.responseJS['notice']){
									
									var p = document.createElement('p');
									p.innerHTML = req.responseJS['notice'][i];
									popUpBoxContentObj.appendChild(p);
									
								}
								
							popUpBoxObj.style.display = '';
							
						}
						
						var totalQtyObj = document.getElementsByClassName('totalQtyObj');
						for(var vi in totalQtyObj){
							if(totalQtyObj.hasOwnProperty(vi) && totalQtyObj[vi]){
								totalQtyObj[vi].innerHTML = req.responseJS['total_quantity'];
							}
						}
						
						var totalCostObj = document.getElementsByClassName('totalCostObj');
						for(var vi in totalCostObj){
							if(totalCostObj.hasOwnProperty(vi) && totalCostObj[vi]){
								totalCostObj[vi].innerHTML = req.responseJS['total_cost'];
							}
						}
						
						/*
						document.getElementById('basketItemsQty').innerHTML = req.responseJS['total_quantity'];
						document.getElementById('basketItemsPrice').innerHTML = req.responseJS['total_cost'];
						document.getElementById('basketItemsPriceNotax').innerHTML = req.responseJS['total_cost_notax'];
						*/
						
					}
				}
				
				req.caching = false;
				req.open('POST', './?jsRequest', true);
				req.send({'jsRequest': true, 'to_basket': to_basket});
				
			//----- Sending save request ------|
			
		}
		
		return false;
		
	}
	
	
	var lastUpdatedAdditionals = false;
	
	this.saveAdditionals = function(){
		
		var newAdditionals = {};
		
		var tmpBox = popUpBoxContentObj.getElementsByClassName('warranty_item');
		if(tmpBox){
			for(var i in tmpBox){
				if(tmpBox.hasOwnProperty(i) && tmpBox[i]){
					
					var itemKey = popUpBoxContentObj.getAttribute('key');
					
					if(!newAdditionals[itemKey]){
						newAdditionals[itemKey] = {'empty': 0};
					}
					
					var input = tmpBox[i].getElementsByTagName('input')[0];
					if(input.checked){
						var select = tmpBox[i].getElementsByTagName('select')[0];
						newAdditionals[itemKey][select.name] = select.value;
					}
					
				}
			}
		}
		
		if(JSON.stringify(newAdditionals)!=JSON.stringify(lastUpdatedAdditionals)){
			
			lastUpdatedAdditionals = newAdditionals;
			
			console.warn(newAdditionals);
			
			var req = new JsHttpRequest();
			req.onreadystatechange = function(){}
			req.caching = false;
			req.open('POST', './?jsRequest', true);
			req.send({'jsRequest': true, 'updateAdditionals': newAdditionals});
			
		}
		
	}
	
	this.getItems = function(){
		
		
		
		
		
		
		
		
	}
	
}

var basket = new basketClass();

function goBack(){
	var refURL = document.referrer;
	if(refURL.substring(0, 20)=='https://datagate.ee/'){
		location.href = refURL;
		return false;
	}
}